import { render, staticRenderFns } from "./TaValInput.vue?vue&type=template&id=135ddba6&"
import script from "./TaValInput.vue?vue&type=script&lang=js&"
export * from "./TaValInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports